import { QuickActions } from './components/quickActions/QuickActions';
import { YourInsights } from './components/yourInsights/YourInsights';
import { useGetVehiclesV2Query } from '../../codegen/vehicles';
import { useEffect } from 'react';
import { OurPartners } from './components/ourPartners/OurPartners';
import { Resources } from './components/resources/Resources';

export const OverviewPage = () => {
  const { refetch } = useGetVehiclesV2Query();

  useEffect(() => {
    refetch();
  }, []);

  return (
    <div className="container-fluid fluid-default">
      <QuickActions />
      <YourInsights />
      <OurPartners />
      <Resources />
    </div>
  );
};
